export function Button({id,label, color, onClick,type,disabled}){
	return (
		<button id={id} className={color} onClick={onClick} type={type} disabled={disabled }>
			{label ?? "Label"}
		</button>
	)
}